import { render, staticRenderFns } from "./MypageTicketTodayTableParts.vue?vue&type=template&id=3f97ee03&scoped=true"
import script from "./MypageTicketTodayTableParts.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodayTableParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodayTableParts.vue?vue&type=style&index=0&id=3f97ee03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f97ee03",
  null
  
)

export default component.exports